import { Controller } from '@hotwired/stimulus';

/**
 * Handles retry functionality for inline statement creation errors.
 * When an error occurs, this controller shows a simplified error display
 * with a retry button that restores the original form.
 */
export default class extends Controller {
  static values = {
    invoiceId: String,
    date: String,
    amount: String,
    formAction: String,
    modalId: String,
    createLabel: String,
  };

  retry() {
    const frameId = `inline-statement-result-${this.invoiceIdValue}`;
    const frame = document.getElementById(frameId);

    if (!frame) return;

    // Build the original form HTML with preserved values
    const formHtml = this.buildFormHtml();
    frame.innerHTML = formHtml;
  }

  buildFormHtml() {
    const invoiceId = this.invoiceIdValue;
    const dateValue = this.dateValue || '';
    const amountValue = this.amountValue || '';
    const formAction = this.formActionValue;
    const modalId = this.modalIdValue;
    const turboFrame = `inline-statement-result-${invoiceId}`;
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';

    return `
      <form data-controller="inline-statement"
            data-turbo-frame="${turboFrame}"
            data-inline-statement-modal-id-value="${modalId}"
            action="${formAction}"
            accept-charset="UTF-8"
            method="post"
            class="space-y-3">
        <input type="hidden" name="authenticity_token" value="${csrfToken}" autocomplete="off">
        <input type="hidden" name="work_progress_statement[invoice_document_id]" value="${invoiceId}">
        <input type="hidden" name="work_progress_statement[statement_type]" value="progress">
        <input type="hidden" name="inline_modal_id" value="${modalId}">

        <div>
          <label for="inline_date_${invoiceId}" class="block text-xs text-neutral-600 mb-1">Date</label>
          <input type="date"
                 id="inline_date_${invoiceId}"
                 name="work_progress_statement[date]"
                 value="${dateValue}"
                 class="block w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm">
        </div>

        <div>
          <label for="inline_amount_${invoiceId}" class="block text-xs text-neutral-600 mb-1">Montant HT</label>
          <div class="relative">
            <input type="number"
                   id="inline_amount_${invoiceId}"
                   name="work_progress_statement[period_amount_ht_input]"
                   value="${amountValue}"
                   step="0.01"
                   class="block w-full px-3 py-2 pr-12 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-sm">
            <span class="absolute inset-y-0 right-0 flex items-center pr-3 text-neutral-500 text-sm">EUR</span>
          </div>
        </div>

        <button type="submit"
                data-testid="submit-statement"
                class="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg text-white bg-primary-600 hover:bg-primary-700 transition-colors shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          ${this.createLabelValue || 'Créer la situation'}
        </button>
      </form>
    `;
  }
}
